const InformationCircleIcon = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1268_596)">
			<g clipPath="url(#clip1_1268_596)">
				<path
					d="M8.0026 1.33203C11.6846 1.33203 14.6693 4.3167 14.6693 7.9987C14.6707 9.74901 13.9836 11.4297 12.7565 12.6778C11.5294 13.9259 9.86071 14.6414 8.11062 14.6698C6.36053 14.6981 4.6695 14.0371 3.4026 12.8294C2.13571 11.6216 1.3946 9.96414 1.33927 8.2147L1.33594 7.9987L1.3386 7.81203C1.43727 4.2167 4.3826 1.33203 8.0026 1.33203ZM8.0026 7.33203H7.33594L7.25794 7.3367C7.0959 7.35597 6.94657 7.434 6.83821 7.55601C6.72986 7.67801 6.67001 7.83552 6.67001 7.9987C6.67001 8.16187 6.72986 8.31938 6.83821 8.44139C6.94657 8.56339 7.0959 8.64142 7.25794 8.6607L7.33594 8.66536V10.6654L7.3406 10.7434C7.35815 10.8922 7.42532 11.0307 7.53128 11.1367C7.63723 11.2426 7.77579 11.3098 7.9246 11.3274L8.0026 11.332H8.66927L8.74727 11.3274C8.89608 11.3098 9.03464 11.2426 9.1406 11.1367C9.24655 11.0307 9.31372 10.8922 9.33127 10.7434L9.33594 10.6654L9.33127 10.5874C9.31533 10.4514 9.2579 10.3235 9.16677 10.2213C9.07564 10.1191 8.95524 10.0474 8.82194 10.016L8.74727 10.0027L8.66927 9.9987V7.9987L8.6646 7.9207C8.64706 7.77189 8.57988 7.63333 8.47393 7.52737C8.36798 7.42142 8.22942 7.35425 8.0806 7.3367L8.0026 7.33203ZM8.00927 5.33203L7.9246 5.3367C7.76257 5.35597 7.61323 5.434 7.50488 5.55601C7.39653 5.67801 7.33668 5.83552 7.33668 5.9987C7.33668 6.16187 7.39653 6.31938 7.50488 6.44139C7.61323 6.56339 7.76257 6.64142 7.9246 6.6607L8.0026 6.66536L8.08727 6.6607C8.2493 6.64142 8.39864 6.56339 8.507 6.44139C8.61535 6.31938 8.67519 6.16187 8.67519 5.9987C8.67519 5.83552 8.61535 5.67801 8.507 5.55601C8.39864 5.434 8.2493 5.35597 8.08727 5.3367L8.00927 5.33203Z"
					fill="#5D6776"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_1268_596">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_1268_596">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default InformationCircleIcon;
